/**
 *
 * # Example of Usage:
 *
 * 1 - Basic usage
 *    <TextArea value={this.state.textAreaValue} onChange={this.handleTextAreaChange}/>
 *
 * 2 - Full usage
 *  <TextArea height="50" maxHeight="100" width="300" value={this.state.textAreaValue} onChange={this.handleTextAreaChange} onFocus={this.handleTextAreaFocus}/>
 *
 * Note: This component needs a value and a onChange created in it's father
 *
 */

var cx = require("classnames");
var PureRenderMixin = React.addons.PureRenderMixin;
var CharactersRemaining = require("app/shared/components/CharactersRemaining/characters-remaining");

var TextArea = React.createClass({
  mixins: [PureRenderMixin],
  propTypes: {
    height: React.PropTypes.string,
    onChange: React.PropTypes.func.isRequired,
    onFocus: React.PropTypes.func,
    maxHeight: React.PropTypes.string,
    placeholder: React.PropTypes.string,
    value: React.PropTypes.string,
    width: React.PropTypes.string,
    isDisabled: React.PropTypes.bool,
    maxLength: React.PropTypes.number,
    className: React.PropTypes.string,
    showMaxLengthCounter: React.PropTypes.bool
  },
  getDefaultProps: function() {
    return {
      height: "35",
      width: "200",
      isDisabled: false,
      showMaxLengthCounter: false
    };
  },
  getInitialState: function() {
    return {
      height: this.props.height
    };
  },
  componentDidMount: function() {
    this.setDynamicHeight();
  },
  componentDidUpdate: function(prevProps, prevState) {
    this.setDynamicHeight();
  },
  setDynamicHeight: function () {
    if (this.refs.textArea) {
      this.setState({
        height: this.calculateDynamicHeight()
      });
    }
  },
  calculateDynamicHeight: function() {
    var scrollHeightInt = parseInt(this.refs.textArea.scrollHeight);
    var maxHeightInt = parseInt(this.props.maxHeight);
    var heightInt = parseInt(this.state.height);

    var isMaxHeightExceeded = scrollHeightInt > maxHeightInt;
    var isHeightExceeded = scrollHeightInt >= heightInt;

    var newHeight;

    if (isMaxHeightExceeded) {
      newHeight = this.props.maxHeight;
    } else if (isHeightExceeded) {
      newHeight = this.refs.textArea.scrollHeight;
    } else {
      newHeight = this.props.height;
    }

    return newHeight;
  },
  handleFocus: function(e) {
    if (this.props.onFocus) {
      this.props.onFocus(e);
    }
  },
  handleChange: function(e) {
    if (this.props.onChange) {
      if (this.props.maxLength) {
        e.target.value = this.applyMaxLength(e.target.value);
      }
      this.props.onChange(e);
    }
  },
  applyMaxLength: function(string) {
    var maxLength = this.props.maxLength;

    if (string.length <= maxLength) {
      return string;
    } else {
      string = string.substring(0, maxLength);
      return string;
    }
  },
  render: function() {
    var className = cx(
      "inputText fs-14 r-n",
      { "ovf-h": this.state.height !== this.props.maxHeight },
      { "bg-lightGray" : this.props.isDisabled },
      this.props.className
    );

    var value = this.props.value || "";
    var visibleCharactersRemaining = (
      this.props.showMaxLengthCounter &&
      this.props.maxLength &&
      !this.props.isDisabled
    );

    return (
      <div className="p-r">
        <textarea
          className={className}
          onChange={this.handleChange}
          onFocus={this.handleFocus}
          placeholder={this.props.placeholder}
          ref="textArea"
          style={{
            width: this.props.width + "px",
            height: this.state.height + "px",
            maxHeight: this.props.maxHeight + "px"
          }}
          value={value}
          disabled={this.props.isDisabled} />
        {
          visibleCharactersRemaining
          ? <CharactersRemaining
              stringLimit={this.props.maxLength}
              stringToWatch={value}
              className="f-r fs-12 fst-italic p-a r-5 b-3 c-999" />
          : null
        }
      </div>
    );
  }
});

module.exports = TextArea;



// WEBPACK FOOTER //
// ./app/shared/components/TextArea/text-area.jsx